module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-forget-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm._f("ftc")('user/check_title')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCodeError !== ''),
      expression: "isCodeError !== ''"
    }],
    staticClass: "alert alert-danger code-error",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.isCodeError)),
      expression: "localeFtc(isCodeError)"
    }]
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== '' && _vm.successMessage !== false),
      expression: "successMessage !== '' && successMessage !== false"
    }],
    staticClass: "alert alert-success code-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.successMessage)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left code-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page1')) + " "), _c('a', {
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec01fa4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/UserCheck.vue
// module id = 454
// module chunks = 0